module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_shiny.f499536b.svg";